import Label from '../../../../../ui/label'
import TheadCoverage from './thead-coverage';
import TBodyCoverage from './tbody-coverage';
import { useMemo } from 'react';
import { THead } from '../../../../../../features/auth/auth-state';
import { ForBorrowerAge } from '../../../../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.state';

interface Props {
    isPreview: boolean;
    isProductGPA: boolean;
    isProductGCLI: boolean;
    isProductGYRT: boolean;
    isProductGCI: boolean;
    borrowerAgeOptionsList: ForBorrowerAge[]
    minAge: number | null
    maxAge: number | null
}

export default function ClientInputForBorrowers({ borrowerAgeOptionsList, minAge, maxAge, isPreview, isProductGPA, isProductGCLI, isProductGYRT, isProductGCI }: Props) {

    const showRate = isProductGCLI || isProductGYRT || isProductGCI;
    const theadForSummaryOfBenefits = useMemo<THead[]>(() => [
        { id: 1, name: "Eligibility Age" },
        { id: 2, name: "Benefit Amount" },
        { id: 3, name: "Rate" },
        // ...(!isProductGPA ? [{ id: 3, name: "Rate" }] : []),
    ], [isProductGPA]);
    
    return (
        <div className="flex h-full flex-col">
            {!isPreview && (
                <div className="flex items-start gap-2.5 border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-3 py-3 sm:px-4">
                    <div>
                        <Label
                            label="Eligibility Age and Benefit Amount"
                            fontSize="text-xs"
                            fontWeight="font-semibold text-gray-800"
                        />
                        <p className="mt-1 text-[11px] leading-4 text-gray-500 sm:text-xs">
                            Configure the benefit amount and applicable rate for each eligible age bracket.
                        </p>
                    </div>
                </div>
            )}
            <div className={`${isPreview ? '' : 'flex-1 overflow-x-auto p-3 md:p-4'}`}>
                <div className="w-full min-w-0 overflow-hidden">
                    <div className="w-full max-w-full overflow-x-auto overscroll-x-contain">
                        <table className="w-full min-w-[560px] table-fixed border-collapse sm:min-w-[640px] lg:min-w-0">
                            <TheadCoverage thead={theadForSummaryOfBenefits} />
                            <TBodyCoverage 
                                isPreview={isPreview} 
                                isProductGPA={isProductGPA}
                                isProductGCLI={isProductGCLI}
                                isProductGYRT={isProductGYRT}
                                isProductGCI={isProductGCI}
                                borrowerAgeOptionsList={borrowerAgeOptionsList}
                                minAge={minAge}
                                maxAge={maxAge}
                            />
                        </table>
                    </div>
                </div>
            </div>
        </div>

    )
}